import React, { useEffect, useState } from "react";

import SliderComponent from "../../../components/SliderComponent/SliderComponent";
import { useDebounce } from "../../../hooks";

const RecommendationCard = (props: any) => {
  const { handleRatingChange, question } = props;
  const [localValue, setLocalValue] = useState<any>(10);
  const debouncedValue = useDebounce(localValue, 300);

  const handleChange = (event: Event, newValue: number | number[]) => {
    setLocalValue(newValue as number);
  };

  useEffect(() => {
    handleRatingChange(debouncedValue);
  }, [debouncedValue]);

  return (

    <div className="flex flex-col items-start self-stretch gap-3 p-4 rounded-lg bg-white
            border border-taupe-50">
      {/* head */}
      <div className="flex flex-col gap-[2px] items-start">
        <h3 className="text-base font-bold leading-5">{question.question}</h3>
        <h3 className="text-sm leading-5">
          {question.subText}</h3>
      </div>
      {/* head end */}

      {/* Recommend Us Card */}
      <p className="w-full text-2xl text-center font-bold">{localValue}</p>
      <SliderComponent value={localValue} handleRecommendationChange={handleChange}/>
      {/* Recommend Us Card end */}
      <div className="w-full flex justify-between">
        <div className="flex flex-col gap-[2px]">
          <p className="text-base font-bold self-start">1</p>
          <p className="text-xs text-gray-1">Not Likely At All</p>
        </div>
        <div className="flex flex-col gap-[2px]">
          <p className="text-base font-bold self-end">10</p>
          <p className="text-xs text-gray-1">Extremely Likely </p>
        </div>
      </div>
    </div>
  );
};

export default RecommendationCard;
